// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ft-affix[data-v-3d2a046b]{display:block}.ft-affix[data-v-3d2a046b]:after{clear:both;content:\"\";display:block}.ft-affix.affix[data-v-3d2a046b]{position:fixed!important;top:75px}body.enable-skin .ft-affix.affix[data-v-3d2a046b]{top:200px}.affix-container[data-v-3d2a046b]{overflow:hidden}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
